import { render, staticRenderFns } from "./Internal-Incident-Report.vue?vue&type=template&id=5b3427dc"
import script from "./Internal-Incident-Report.vue?vue&type=script&lang=js"
export * from "./Internal-Incident-Report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports